<lib-file-selector
  (emitFile)="getFileDetails($event)"
  [allowMultiple]="allowMultiple"
  [acceptedFiles]="acceptedFiles"
  [validation]="validation"
  [info]="info"
  [subInfo]="subInfo"
></lib-file-selector>
